import { set, cloneDeep } from 'lodash-es';
import type { EntityDetailSchema } from '../../types/schemas';

export const getConfigEntitySchemaWithDomainEntityAttributes = (
  configEntitySchema: EntityDetailSchema,
  domainEntitySchema: EntityDetailSchema,
) => {
  const schemaCopy = cloneDeep(configEntitySchema);
  // Copy the domain entity's attributes schema into the config entity's schema
  const configSchemaWithDomainSchemaAttributes = set(
    schemaCopy,
    'properties.attributes.properties.domainEntityAttributes',
    domainEntitySchema.properties.attributes,
  );

  return configSchemaWithDomainSchemaAttributes;
};
